import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { SabloaneService } from '../../sabloane/sabloane.service';
import { InboxService } from '../inbox.service';

@Component({
    selector: 'app-sabloane',
    templateUrl: './sabloane.component.html',
    styleUrls: ['./sabloane.component.scss']
})
export class SabloaneComponent {
    isLoading = false;
    helper = helper;
    sabloaneData: any[] = [];

    constructor(
        private dialogRef: MatDialogRef<SabloaneComponent>,
        private sabloaneService: SabloaneService,
        private inboxService: InboxService
    ) { }

    ngOnInit(): void {
        this.getSabloane();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    getSabloane() {
        this.isLoading = true;
        this.sabloaneService
            .getSabloane()
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe((response: any) => {
                this.sabloaneData = response.data;
            });
    }

    sendSablon(sablonContent: string) {
        this.inboxService.sendContent(sablonContent);
        this.closeDialog();
    }
}
